module.exports = __webpack_public_path__ + "static/media/cs50_ide_file_tree.fa4a80bc.png";